import React from "react";

const RVModal = ({ roleName, usersForRole, privilegeForRole }) => {
  return (
    <>
      <div className="modal modal-lg fade" tabindex="-1" id="modalDefault">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <a
              href="#"
              className="close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <em className="icon ni ni-cross"></em>
            </a>
            <div className="modal-header">
              <h5 className="modal-title">{roleName}</h5>
            </div>
            <div className="modal-body">
              <div className="card card-full">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="card-inner">
                      <div className="card-title-group">
                        <div className="card-title">
                          <h6 className="title">Users</h6>
                        </div>
                      </div>
                    </div>
                    {usersForRole.length > 0 ? (
                      <ul className="nk-activity">
                        {usersForRole.map((user, index) => (
                          <li className="nk-activity-item" key={index}>
                            <div className="nk-activity-data">
                              <div className="label">{user}</div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="p-4">No users assigned to this role.</p>
                    )}
                  </div>
                  <div className="col-lg-6">
                    <div className="card-inner">
                      <div className="card-title-group">
                        <div className="card-title">
                          <h6 className="title">Privilege</h6>
                        </div>
                      </div>
                    </div>
                    {privilegeForRole.length > 0 ? (
                      <ul className="nk-activity">
                        {privilegeForRole.map((privi, index) => (
                          <li className="nk-activity-item" key={index}>
                            <div className="nk-activity-data">
                              <div className="label">
                                {privi.privilege_name}
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="p-4">No Privileges assigned to this role.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer bg-light">
              <span className="sub-text">Modal Footer Text</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RVModal;
